import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import TabsPage from '../views/TabsPage.vue'
import { useAppStore } from '@/store/modules/app'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/login',
    meta: {
      noNeedAuth: true
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: {
      noNeedAuth: true
    },
  },
  {
    path: '/tabs/',
    component: TabsPage,
    children: [
      {
        path: '',
        name: 'Main',
        redirect: '/tabs/tab3'
      },
      {
        path: 'tab1',
        component: () => import('@/views/Tab1Page.vue')
      },
      {
        path: 'tab2',
        component: () => import('@/views/Tab2Page.vue')
      },
      //---------正課
      {
        path: 'tab3',
        component: () => import('@/views/Tab3Page.vue')
      },
      {
        path: 'tab3/rollcall',
        component: () => import('@/views/tab3/RollcallPage.vue'),
      },
      {
        path: 'tab3/auditionStudentEdit',
        component: () => import('@/views/tab3/AuditionStudentEditPage.vue'),
      },
      {
        path: 'tab3/feed',
        component: () => import('@/views/tab3/FeedPage.vue'),
      },
      {
        path: 'tab3/grade',
        component: () => import('@/views/tab3/GradePage.vue'),
      },
      {
        path: 'tab3/gradeTest',
        component: () => import('@/views/tab3/GradeTestPage.vue'),
      },
      {
        path: 'tab3/gradeTestEdit',
        component: () => import('@/views/tab3/GradeTestEditPage.vue'),
      },
      {
        path: 'tab3/report',
        component: () => import('@/views/tab3/ReportPage.vue'),
      },
      //---------缺課名單
      {
        path: 'tab3/absent',
        component: () => import('@/views/tab3/AbsentPage.vue'),
      },
      //---------輔導課
      {
        path: 'tab3/tutor',
        component: () => import('@/views/tab3/tutor/TutorPage.vue')
      },
      {
        path: 'tab3/tutor/rollcall',
        component: () => import('@/views/tab3/tutor/RollcallPage.vue'),
      },
      {
        path: 'tab3/tutor/feed',
        component: () => import('@/views/tab3/tutor/FeedPage.vue'),
      },
      {
        path: 'tab3/tutor/homework',
        component: () => import('@/views/tab3/tutor/HomeworkPage.vue'),
      },
      {
        path: 'tab4',
        component: () => import('@/views/Tab4Page.vue')
      },
      {
        path: 'tab4/studentList',
        component: () => import('@/views/tab4/StudentListPage.vue'),
      },
      {
        path: 'tab4/studentLeave',
        component: () => import('@/views/tab4/StudentLeavePage.vue'),
      },
      {
        path: 'tab4/studentChange',
        component: () => import('@/views/tab4/StudentChangePage.vue'),
      },
      {
        path: 'tab4/studentGraduate',
        component: () => import('@/views/tab4/StudentGraduatePage.vue'),
      },
      {
        path: 'tab4/studentGraduateAll',
        component: () => import('@/views/tab4/StudentGraduateAllPage.vue'),
      },
      {
        path: 'tab4/studentEdit',
        component: () => import('@/views/tab4/StudentEditPage.vue'),
      },
      {
        path: 'tab4/grade',
        component: () => import('@/views/tab4/GradePage.vue'),
      },
      {
        path: 'tab4/gradeTest',
        component: () => import('@/views/tab4/GradeTestPage.vue'),
      },
      {
        path: 'tab4/gradeTestEdit',
        component: () => import('@/views/tab4/GradeTestEditPage.vue'),
      },
      {
        path: 'tab4/curriculum',
        component: () => import('@/views/tab4/CurriculumPage.vue'),
      },
      {
        path: 'tab4/curriculumTeacher',
        component: () => import('@/views/tab4/CurriculumTeacherPage.vue'),
      },
      {
        path: 'tab5',
        component: () => import('@/views/Tab5Page.vue')
      },
      {
        path: 'tab5/paymentEdit',
        component: () => import('@/views/tab5/PaymentEditPage.vue'),
      },
      {
        path: 'tab5/studentPayment',
        component: () => import('@/views/tab5/StudentPaymentPage.vue'),
      },
      {
        path: 'tab6',
        component: () => import('@/views/Tab6Page.vue')
      },
      {
        path: 'tab6/changePassword',
        component: () => import('@/views/tab6/ChangePasswordPage.vue')
      },
      {
        path: 'tab6/setClassRollTimePage',
        component: () => import('@/views/tab6/SetClassRollTimePage.vue')
      },
      {
        path: 'tab6/setAssistantTeacherPage',
        component: () => import('@/views/tab6/SetAssistantTeacherPage.vue')
      },
      {
        path: 'manager/tabA',
        component: () => import('@/views/manager/TabAPage.vue')
      },
      {
        path: 'manager/report',
        component: () => import('@/views/tab3/ReportPage.vue')
      },
      {
        path: 'manager/tabB',
        component: () => import('@/views/manager/TabBPage.vue')
      },
      {
        path: 'manager/teacher/classes',
        component: () => import('@/views/teacher/ClassesPage.vue')
      },
      {
        path: 'manager/teacher/diaryList',
        component: () => import('@/views/teacher/DiaryListPage.vue')
      },
      {
        path: 'manager/teacher/transcript',
        component: () => import('@/views/teacher/TranscriptPage.vue')
      },
      {
        path: 'manager/teacher/classAmountHistory',
        component: () => import('@/views/teacher/ClassAmountHistoryPage.vue')
      },
      {
        path: 'manager/tabC',
        component: () => import('@/views/manager/TabCPage.vue')
      },
      {
        path: 'manager/tabD',
        component: () => import('@/views/manager/TabDPage.vue')
      },
      {
        path: 'manager/student/paymentUnpaid',
        component: () => import('@/views/student/paymentUnpaidPage.vue')
      },
    ]
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const appStore = useAppStore()

  // Store 已在 main.ts 中初始化完成，直接取用
  const userInfo = appStore.getUserInfo
  const token = userInfo?.token?.token
  
  if (!to.matched.some(record => record.meta.noNeedAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!token && to.name != "Login") {
      next({ name: 'Login', hash: '#forced' });
    } else if ((to.name == "Login") && token) {
      next({ name: 'Main' });
    } else {
      next() // go to wherever I'm going
    }
  } else {
    next() // does not require auth, make sure to always call next()!
  }
})

export default router
